<template>
    <layout-bigscreen nav_top="0">
        <div id="antdVue" ref="antdVue" :style="themeColorInit(themeColorConfig)" class="zoom_bg_color" style="width:100%; height:100%;">
            <div class="antdVue" :style="{...calculateStyles}">

                <div class="flex flex-direction justify-center benben-flex-layout lianmengfenxidaping_306_random_flex_0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100">
                    <div class="flex flex-wrap align-center justify-center lianmengfenxidaping_213_fd0_0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100 f-c-3 position-relative bg-size-auto">
                        <div class="flex  flex-wrap align-center lianmengfenxidaping_224_fd0_0_c0 position-absolute">
                            <img class='lianmengfenxidaping_976_fd0_0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/03e56738af5b3ecc593d3c6c58203cc6.png" />
                            <span class="lianmengfenxidaping_355_fd0_0_c0_c1 t-20 t-w-4">多云</span>
                            <div class="flex  flex-wrap align-center lianmengfenxidaping_171_fd0_0_c0_c2 bg-size-auto">

                            </div>
                            <span class="lianmengfenxidaping_919_fd0_0_c0_c3 t-20 h-10-px t-w-4">6</span>
                            <span class="lianmengfenxidaping_919_fd0_0_c0_c3 t-20 h-10-px t-w-4">℃</span>

                        </div>
                        <img class='lianmengfenxidaping_202_fd0_0_c1' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/e86a55b2a20775c71c1fb6cc91dd3c1e.png" />
                        <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">联盟分析大屏</span>
                        <img class='lianmengfenxidaping_512_fd0_0_c3' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/d3adc8fbbce7c9aa2bbd0f8ae8ac5a40.png" />
                        <div class="flex align-center lianmengfenxidaping_951_fd0_0_c4 position-absolute">
                            <img class='lianmengfenxidaping_900_fd0_0_c4_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/2af63761ef0068fdbbfded13de1d740c.png" />

                            <benben-real-time class='flex align-center justify-center lianmengfenxidaping_948_random_fd0_0_c4_c1 t-18 t-w-4' format="YYYY-MM-DD HH:mm:ss" :has_week="true" :refresh_interval="500" show_title="true" title_position="left" title_name="标题">

                            </benben-real-time>


                        </div>

                        <benben-full-screen class='flex align-center justify-center lianmengfenxidaping_111_random_fd0_0_c5 position-absolute a'>

                        </benben-full-screen>


                    </div>

                    <a-row class="benben-grid   w-100" :gutter="[20,8]" type="flex">

                        <a-col :xs="24" :md="6" :xl="6" :xxl="6">
                            <div class="flex  flex-wrap align-center  w-100">
                                <div class="flex flex-direction align-start lianmengfenxidaping_853_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-100">
                                    <span class="lianmengfenxidaping_531_fd0_1_c0_c0_c0_c0 f-c-3 t-20">联盟订单交易金额</span>
                                    <div class="flex  flex-wrap align-center lianmengfenxidaping_217_fd0_1_c0_c0_c0_c1 w-100 bg-size-auto">

                                    </div>

                                    <benben-bar-base class='w-100 h-100' :field-options="distributorAmountChart" data_source_type="1" chart_show_type="bar-base" show_title="false" title_position="left" title_name="标题" :linear_gradient_color="[{'start':50,'color1':'#00F4D8','color2':'#C4FF00'}]" :open_data_loop="true" :data_loop_num="4" :data_loop_delay="10" label_limit="6" :chart-option="chartOptions_random_4442">

                                    </benben-bar-base>


                                </div>
                                <div class="flex flex-direction align-start lianmengfenxidaping_853_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-100">
                                    <span class="lianmengfenxidaping_531_fd0_1_c0_c0_c0_c0 f-c-3 t-20">联盟订单</span>
                                    <div class="flex  flex-wrap align-center lianmengfenxidaping_217_fd0_1_c0_c0_c0_c1 w-100 bg-size-auto">

                                    </div>
                                    <div class="flex align-center  w-100 h-100">

                                        <benben-line-area-accumul class='lianmengfenxidaping_484_random_fd0_1_c0_c0_c1_c2_c0 w-100' :field-options="distributorCountChart" data_source_type="1" chart_show_type="line-area-accumul" show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_6672" :chart-option="chartOptions_random_5843">

                                        </benben-line-area-accumul>


                                    </div>

                                </div>
                                <div class="flex flex-direction align-start lianmengfenxidaping_853_fd0_1_c0_c0_c0 w-100 bg-size-100">
                                    <span class="lianmengfenxidaping_531_fd0_1_c0_c0_c0_c0 f-c-3 t-20">近一月联盟用户完成单量</span>
                                    <div class="flex  flex-wrap align-center lianmengfenxidaping_217_fd0_1_c0_c0_c0_c1 w-100 bg-size-auto">

                                    </div>
                                    <div class="flex flex-wrap align-center flex-sub  w-100">

                                        <big-screen-custom-table class='lianmengfenxidaping_847_random_fd0_1_c0_c0_c2_c2_c0 t-14 f-c-fff' :field-options="distributorUserOrderCount" data_source_type="1" chart_show_type="big_screen_table" :new_width="true" width="100%" height="100%" :show_num="7" sort_order="desc" sort_field="num" sort_name="序号" :sort_width="10" select_field="" :show_progress="false" :theme_color="theme_color_1549" play_type="all_num" :interval="5" :delay="3" :show_header="true" :head_height="40" :row_gutter="0" :column_config="[]">
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="one">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/07410c01c6b5f0a1e2d49e5a5727e547.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="two">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/bf1b79a1af40a4037a7c575736bd7300.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="three">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/9c17908cf8ecccd852a1956e9c3f7f2e.png" />

                                            </div>
                                            <template v-slot:other="{index}">
                                                <div class="flex align-center self-center justify-center  w-100 h-100 t-14">
                                                    <div class="flex flex justify-center align-center">
                                                        <span>{{index}}</span>

                                                    </div>

                                                </div>
                                            </template>

                                        </big-screen-custom-table>


                                    </div>

                                </div>

                            </div>

                        </a-col>


                        <a-col :xs="24" :md="12" :xl="12" :xxl="12">
                            <div class="flex  flex-wrap align-center  w-100">
                                <div class="flex flex-direction align-center lianmengfenxidaping_707_fd0_1_c1_c0_c0 w-100 bg-size-100">
                                    <div class="flex align-center justify-between lianmengfenxidaping_924_fd0_1_c1_c0_c0_c0 w-100">
                                        <div class="flex flex-direction flex-wrap align-center lianmengfenxidaping_923_fd0_1_c1_c0_c0_c0_c0">
                                            <span class="lianmengfenxidaping_152_fd0_1_c1_c0_c0_c0_c0_c0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 t-20 lh-24-px f-c-fff">联盟用户总数</span>

                                            <benben-light-text class='light-text lianmengfenxidaping_517_random_fd0_1_c1_c0_c0_c0_c0_c1 t-36 lh-24-px t-w-4' :field-options="distributorUserCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                            </benben-light-text>


                                        </div>
                                        <div class="flex flex-direction align-center lianmengfenxidaping_923_fd0_1_c1_c0_c0_c0_c0">
                                            <span class="lianmengfenxidaping_578_fd0_1_c1_c0_c0_c0_c1_c0 t-20 lh-24-px f-c-fff">联盟邀请注册</span>

                                            <benben-light-text class='light-text lianmengfenxidaping_121_random_fd0_1_c1_c0_c0_c0_c1_c1 t-36' :field-options="inviteUserCount" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                            </benben-light-text>


                                        </div>

                                    </div>
                                    <div class="flex align-center justify-between lianmengfenxidaping_743_fd0_1_c1_c0_c0_c1 w-100">
                                        <div class="flex flex-direction flex-wrap align-center lianmengfenxidaping_923_fd0_1_c1_c0_c0_c0_c0">
                                            <span class="lianmengfenxidaping_578_fd0_1_c1_c0_c0_c0_c1_c0 t-20 lh-24-px f-c-fff">近7天分销单数</span>
                                            <div class="flex  flex-wrap align-center">

                                                <benben-light-text class='light-text lianmengfenxidaping_929_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-36' :field-options="distributorOrderCount7" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>


                                            </div>

                                        </div>
                                        <div class="flex flex-direction align-center lianmengfenxidaping_923_fd0_1_c1_c0_c0_c0_c0">
                                            <span class="lianmengfenxidaping_578_fd0_1_c1_c0_c0_c0_c1_c0 t-20 lh-24-px f-c-fff">近7天分佣金额</span>

                                            <benben-light-text class='light-text lianmengfenxidaping_929_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 t-36' :field-options="distributorAmount7" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                            </benben-light-text>


                                        </div>

                                    </div>
                                    <div class="flex align-center justify-center lianmengfenxidaping_970_fd0_1_c1_c0_c0_c2 w-100">
                                        <div class="flex flex-direction flex-wrap align-center lianmengfenxidaping_923_fd0_1_c1_c0_c0_c0_c0">
                                            <span class="lianmengfenxidaping_578_fd0_1_c1_c0_c0_c0_c1_c0 t-20 lh-24-px f-c-fff">近7天分销订单金额</span>
                                            <div class="flex  flex-wrap align-center">

                                                <benben-light-text class='light-text lianmengfenxidaping_387_random_fd0_1_c1_c0_c0_c2_c0_c1_c0 t-36' :field-options="distributorOrderAmount7" data_source_type="1" chart_show_type="simple-text" :is_abs="false">

                                                </benben-light-text>


                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                            <div class="flex flex-wrap align-center justify-between  w-100">
                                <div class="flex flex-direction align-start lianmengfenxidaping_883_fd0_1_c1_c1_c0 bg-size-100">
                                    <div class="flex flex-wrap align-center justify-between  w-100">
                                        <span class="lianmengfenxidaping_531_fd0_1_c0_c0_c0_c0 f-c-3 t-20">近一月联盟邀请用户</span>

                                    </div>
                                    <div class="flex  flex-wrap align-center lianmengfenxidaping_807_fd0_1_c1_c1_c0_c1 w-100 bg-size-auto">

                                    </div>
                                    <div class="flex flex-wrap align-center flex-sub  w-100">

                                        <big-screen-custom-table class='lianmengfenxidaping_847_random_fd0_1_c0_c0_c2_c2_c0 t-14 f-c-fff' :field-options="distributorUserInviteList" data_source_type="1" chart_show_type="big_screen_table" :new_width="true" width="100%" height="100%" :show_num="7" sort_order="desc" sort_field="num" sort_name="序号" :sort_width="10" select_field="" :show_progress="false" :theme_color="theme_color_3245" play_type="all_num" :interval="5" :delay="3" :show_header="true" :head_height="40" :row_gutter="0" :column_config="[]">
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="one">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/07410c01c6b5f0a1e2d49e5a5727e547.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="two">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/bf1b79a1af40a4037a7c575736bd7300.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="three">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/9c17908cf8ecccd852a1956e9c3f7f2e.png" />

                                            </div>
                                            <template v-slot:other="{index}">
                                                <div class="flex align-center self-center justify-center  w-100 h-100 t-14">
                                                    <div class="flex flex justify-center align-center">
                                                        <span>{{index}}</span>

                                                    </div>

                                                </div>
                                            </template>

                                        </big-screen-custom-table>


                                    </div>

                                </div>
                                <div class="flex flex-direction align-start lianmengfenxidaping_883_fd0_1_c1_c1_c0 bg-size-100">
                                    <div class="flex flex-wrap align-center justify-between  w-100">
                                        <span class="lianmengfenxidaping_531_fd0_1_c0_c0_c0_c0 f-c-3 t-20">近一月联盟订单金额</span>

                                    </div>
                                    <div class="flex  flex-wrap align-center lianmengfenxidaping_807_fd0_1_c1_c1_c0_c1 w-100 bg-size-auto">

                                    </div>
                                    <div class="flex flex-wrap align-center flex-sub  w-100">

                                        <big-screen-custom-table class='lianmengfenxidaping_847_random_fd0_1_c0_c0_c2_c2_c0 t-14 f-c-fff' :field-options="distributorUserAmountList" data_source_type="1" chart_show_type="big_screen_table" :new_width="true" width="100%" height="100%" :show_num="7" sort_order="desc" sort_field="num" sort_name="序号" :sort_width="10" select_field="" :show_progress="false" :theme_color="theme_color_6488" play_type="all_num" :interval="5" :delay="3" :show_header="true" :head_height="40" :row_gutter="0" :column_config="[]">
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="one">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/07410c01c6b5f0a1e2d49e5a5727e547.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="two">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/bf1b79a1af40a4037a7c575736bd7300.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="three">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/9c17908cf8ecccd852a1956e9c3f7f2e.png" />

                                            </div>
                                            <template v-slot:other="{index}">
                                                <div class="flex align-center self-center justify-center  w-100 h-100 t-14">
                                                    <div class="flex flex justify-center align-center">
                                                        <span>{{index}}</span>

                                                    </div>

                                                </div>
                                            </template>

                                        </big-screen-custom-table>


                                    </div>

                                </div>

                            </div>

                        </a-col>


                        <a-col :xs="24" :md="6" :xl="6" :xxl="6">
                            <div class="flex  flex-wrap align-center  w-100">
                                <div class="flex flex-direction align-start lianmengfenxidaping_853_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-100">
                                    <span class="lianmengfenxidaping_531_fd0_1_c0_c0_c0_c0 f-c-3 t-20">联盟用户增长</span>
                                    <div class="flex  flex-wrap align-center lianmengfenxidaping_217_fd0_1_c0_c0_c0_c1 w-100 bg-size-auto">

                                    </div>

                                    <benben-bar-base class='w-100 h-100' :field-options="distributorUserGrowth" data_source_type="1" chart_show_type="bar-base" show_title="false" title_position="left" title_name="标题" :linear_gradient_color="[{'start':10,'color1':'#FF8C19','color2':'#FAAB40'}]" label_limit="6" :open_data_loop="true" :data_loop_num="6" :data_loop_delay="10" :theme_color="theme_color_2390" :chart-option="chartOptions_random_4631">

                                    </benben-bar-base>


                                </div>
                                <div class="flex flex-direction align-start lianmengfenxidaping_853_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-100">
                                    <span class="lianmengfenxidaping_531_fd0_1_c0_c0_c0_c0 f-c-3 t-20">联盟用户累计</span>
                                    <div class="flex  flex-wrap align-center lianmengfenxidaping_217_fd0_1_c0_c0_c0_c1 w-100 bg-size-auto">

                                    </div>
                                    <div class="flex align-center  w-100 h-100">

                                        <benben-line-area-accumul class='lianmengfenxidaping_484_random_fd0_1_c0_c0_c1_c2_c0 w-100' :field-options="distributorUserCumulative" data_source_type="1" chart_show_type="line-area-accumul" show_title="false" title_position="left" title_name="标题" :theme_color="theme_color_6470" :chart-option="chartOptions_random_4428">

                                        </benben-line-area-accumul>


                                    </div>

                                </div>
                                <div class="flex flex-direction align-start lianmengfenxidaping_853_fd0_1_c0_c0_c0 w-100 bg-size-100">
                                    <span class="lianmengfenxidaping_531_fd0_1_c0_c0_c0_c0 f-c-3 t-20">近一月联盟商品</span>
                                    <div class="flex  flex-wrap align-center lianmengfenxidaping_217_fd0_1_c0_c0_c0_c1 w-100 bg-size-auto">

                                    </div>
                                    <div class="flex flex-wrap align-center flex-sub  w-100">

                                        <big-screen-custom-table class='lianmengfenxidaping_847_random_fd0_1_c0_c0_c2_c2_c0 t-14 f-c-fff' :field-options="distributorGoodsAmountChart" data_source_type="1" chart_show_type="big_screen_table" :new_width="true" width="100%" height="100%" :show_num="7" sort_order="desc" sort_field="num" sort_name="序号" :sort_width="10" select_field="" :show_progress="false" :theme_color="theme_color_5560" play_type="all_num" :interval="5" :delay="3" :show_header="true" :head_height="40" :row_gutter="0" :column_config="[]">
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="one">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/07410c01c6b5f0a1e2d49e5a5727e547.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="two">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/bf1b79a1af40a4037a7c575736bd7300.png" />

                                            </div>
                                            <div class="flex align-center self-center justify-center  w-100 h-100" slot="three">
                                                <img class='lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20231225/9c17908cf8ecccd852a1956e9c3f7f2e.png" />

                                            </div>
                                            <template v-slot:other="{index}">
                                                <div class="flex align-center self-center justify-center  w-100 h-100 t-14">
                                                    <div class="flex flex justify-center align-center">
                                                        <span>{{index}}</span>

                                                    </div>

                                                </div>
                                            </template>

                                        </big-screen-custom-table>


                                    </div>

                                </div>

                            </div>

                        </a-col>


                    </a-row>


                </div>

            </div>
        </div>
    </layout-bigscreen>
</template>
<script>
    import {
        bigScreenMixins,
        receiveNew
    } from '@/assets/diypaaspc/diy-generate-big-screen-new.js'
    import {
        receive,
        benbenFlexNumberBox,
        scrollList,
        treeSelect,
        simpleSelect,
        multipleSelect,
        cascaderForm,
        checkboxForm,
        switchForm,
        messageReply,
        rangePicker,
        handSignature,
        mixinAddTableItem,
        editorForm,
        qiunDataCharts,
        copyText,
        mixinTableItemChange,
        in_array,
        themeColorInit,
        getUrlKey,
        clearDataPass,
        isEmpty,
        treeEdit
    } from '@/assets/diypaaspc/diy-pass-pc.js'
    import {
        provinceForm
    } from '@/assets/diypaaspc/province_area.js'
    import request from '@/utils/request'
    import * as echarts from 'echarts'
    import 'echarts-gl'
    import 'echarts-liquidfill'
    import {
        mapdata
    } from '@/assets/diypaaspc/mapdata.js'
    import layoutBigscreen from "@/components/layoutBigscreen"
    import moment from 'moment';
    import {distributorAmountChart, distributorGoodsAmountChart, distributorStatistics} from "@/api/statistics/order";
    import {
      distributorUserAmountChart, distributorUserCumulative,
      distributorUserGrowth,
      distributorUserInviteList,
      userSource
    } from "@/api/statistics/user";

    export default {
      name: 'lianmengfenxidaping',
      components: {
        layoutBigscreen
      },
      mixins: [bigScreenMixins],
      data() {
        const themeColorConfig = {
          "presetApi": {
            "getClassifyOne": "",
            "getClassifyTow": "",
            "getClassifyShop": ""
          },
          "themeType": 0,
          "themeConfig": [{
            "colorConfig": ["#333333", "#666666", "#999999", "#ffffff", "#0052c7", "#F02325", "#FC9C3A", "#4DC777", "#F2CC98", "#F2CC66"],
            "bgColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#FC9fff", "#E6F333", "#E6F1FE", "linear-gradient(301deg, #EBBA7B 0%, #F8D9AD 100%)", "linear-gradient(180deg, #F5588E 0%, #F0403C 100%)", "linear-gradient(179deg, #FFD033 0%, #F4890E 100%)"],
            "bdColorConfig": ["#EBEDF8", "#FFFFFF", "#0052c7", "#FC9C3A", "#333333", "#666666", "#999999", "#dddddd", "#1178F0", "#F02325"]
          }]
        };
        receive(this);
        receiveNew(this);
        return {
          themeColorConfig,
          mapdata: mapdata,
          "isFullScreen": false,
          "big_screen_global_query": {
            "screen_global_time_range_type": "5",
            "screen_global_time_custom_time": "",
            "screen_global_dept": "",
            "screen_global_user": ""
          },
          "saizhuge_api_loaded": false,
          "school_info": {},
          "weather_info": {},
          "weather_data": [{
            "name": "晴",
            "code": "0",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
          }, {
            "name": "夜晚晴",
            "code": "1",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
          }, {
            "name": "晴",
            "code": "2",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png"
          }, {
            "name": "夜晚晴",
            "code": "3",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png"
          }, {
            "name": "多云",
            "code": "4",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/937ea42d4d54677a960419fc926d2308.png"
          }, {
            "name": "晴间多云",
            "code": "5",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
          }, {
            "name": "晴间多云",
            "code": "6",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png"
          }, {
            "name": "大部多云",
            "code": "7",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8c1710ce88d626dad374865cc5cc285d.png"
          }, {
            "name": "大部多云",
            "code": "8",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8e47c4a733b6ea39aa94ea362bc942fa.png"
          }, {
            "name": "阴",
            "code": "9",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/b8a945d068a4c968e5c05e023a67571f.png"
          }, {
            "name": "阵雨",
            "code": "10",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2987ff71ec8f90fdffa1c0114e13b1f9.png"
          }, {
            "name": "雷阵雨",
            "code": "11",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/751a274ee37d368cd45471edc5b35411.png"
          }, {
            "name": "雷阵雨伴有冰雹",
            "code": "12",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/2c7657970388a04e29049a23a0046c56.png"
          }, {
            "name": "小雨",
            "code": "13",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/6b02916ef905c0f100e3e6d4bf4c4ff0.png"
          }, {
            "name": "中雨",
            "code": "14",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/cc26fd0d1cda78eda4b53d85718b8803.png"
          }, {
            "name": "大雨",
            "code": "15",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/1598c140199a349d9ec4aed4482f0cf1.png"
          }, {
            "name": "暴雨",
            "code": "16",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
          }, {
            "name": "大暴雨",
            "code": "17",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b460fe42bb0e8dcbc177b5d6ef5b3c30.png"
          }, {
            "name": "特大暴雨",
            "code": "18",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png"
          }, {
            "name": "冻雨",
            "code": "19",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/121096065da289cc9ebf23c778c8a4e8.png"
          }, {
            "name": "雨夹雪",
            "code": "20",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d9c47f9707616842680ba38e1c8e4d43.png"
          }, {
            "name": "阵雪",
            "code": "21",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/af6e554f62f546c76b3b495df7f36eb2.png"
          }, {
            "name": "小雪",
            "code": "22",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/71744d3bd3230b10f5d09666a76657ea.png"
          }, {
            "name": "中雪",
            "code": "23",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a29d1ac31de2a2cdaecfb4c579cdf928.png"
          }, {
            "name": "大雪",
            "code": "24",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/62145c7aea6a3e65c5f1dc8d84f5c92d.png"
          }, {
            "name": "暴雪",
            "code": "25",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/50946c87ed7c0e4c471d7cb0310115c3.png"
          }, {
            "name": "浮尘",
            "code": "26",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/46258a78adc3acf03d0186836e89b798.png"
          }, {
            "name": "扬沙",
            "code": "27",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a2440c63509d48eb1fa45804c6476f7d.png"
          }, {
            "name": "沙尘暴",
            "code": "28",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/9a80471d8001ea814aa4206d3feda602.png"
          }, {
            "name": "强沙尘暴",
            "code": "29",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/da4066fc0584850d72ec402894765b2d.png"
          }, {
            "name": "雾",
            "code": "30",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/4cf7128b075acfd65af6ea175f7240ce.png"
          }, {
            "name": "霾",
            "code": "31",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/c6325f4ef718e9aef9dbff86e2d28817.png"
          }, {
            "name": "风",
            "code": "32",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/dccb4227577c4f0e51c6b9b16fa75af1.png"
          }, {
            "name": "大风",
            "code": "33",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b1d9445881a4a9d0b1471f831d3800c8.png"
          }, {
            "name": "飓风",
            "code": "34",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d58120ad96b2b4df9f4ffb35dc07c3c7.png"
          }, {
            "name": "热带风暴",
            "code": "35",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/3ca919f2ae75739b3196460dfffdd405.png"
          }, {
            "name": "龙卷风",
            "code": "36",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
          }, {
            "name": "冷",
            "code": "37",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png"
          }, {
            "name": "热",
            "code": "38",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d33c81b9f8772998d9bba7d3ea52acb0.png"
          }, {
            "name": "未知",
            "code": "99",
            "img_url": "https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/db353a99b557f85968a262210c69f0d7.png"
          }],
          "viewSource": "PC",
          "big_screen_global_config": {
            "is_screen_global_time": false,
            "is_screen_global_dept": false,
            "is_screen_global_user": false
          },
          "designWidth": 1920,
          "designHeight": 1080,
          "calculateStyles": {},
          "screenWidth": window.innerWidth,
          "screenHeight": window.innerHeight,
          "timerW": false,
          "timerH": false,
          "page_scale": 1,
          "theme_color_5560": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
          "distributorGoodsAmountChart": {
            "columns": [{
              "name": "商品名称",
              "prop": "shopname"
            }, {
              "name": "完成单量",
              "prop": "ordernum"
            }, {
              "name": "商品单价",
              "prop": "shopprice"
            }, {
              "name": "奖励总额度",
              "prop": "award"
            }],
            "rows": [{
              "shopname": "苹果",
              "ordernum": 20,
              "shopprice": 120,
              "award": 20
            }, {
              "shopname": "苹果",
              "ordernum": 20,
              "shopprice": 120,
              "award": 20
            }, {
              "shopname": "苹果",
              "ordernum": 20,
              "shopprice": 120,
              "award": 20
            }, {
              "shopname": "苹果",
              "ordernum": 20,
              "shopprice": 120,
              "award": 20
            }, {
              "shopname": "苹果",
              "ordernum": 20,
              "shopprice": 120,
              "award": 20
            }]
          }, // 近一月联盟商品
          "theme_color_6470": ["#6EC890", "#6AE7E6", "#F27B60", "#F8A200", "#B0D630", "#2d3c98", "#0F36A2", "#FC658A"],
          "chartOptions_random_4428": {
            "tooltip": {
              "show": true,
              "trigger": "axis",
              "axisPointer": {
                "type": "shadow"
              },
              "textStyle": {
                "color": "inherit",
                "fontSize": 14
              }
            },
            "legend": {
              "type": "scroll",
              "textStyle": {
                "color": "#fff"
              },
              "show": false,
              "orient": "horizontal",
              "left": "center",
              "top": ""
            },
            "grid": {
              "left": "1%",
              "right": "2%",
              "bottom": "0%",
              "top": "15%",
              "containLabel": true
            },
            "yAxis": {
              "type": "value",
              "axisTick": {
                "show": false
              },
              "axisLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              },
              "axisLabel": {
                "show": true,
                "color": "#fff",
                "fontSize": 12,
                "fontWeight": 400
              },
              "splitLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              }
            },
            "xAxis": {
              "type": "category",
              "boundaryGap": false,
              "axisTick": {
                "show": true
              },
              "axisLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              },
              "axisLabel": {
                "show": true,
                "color": "#fff",
                "fontSize": 12,
                "fontWeight": 400,
                "rotate": 0
              },
              "splitLine": {
                "show": false,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              }
            },
            "seriesSetting": {
              "areaStyle": {
                "show": true
              },
              "markPoint": {
                "label": {
                  "normal": {
                    "textStyle": {
                      "color": "#fff",
                      "fontSize": 14,
                      "fontWeight": 400
                    }
                  }
                },
                "itemStyle": [],
                "data": [],
                "symbol": "pin",
                "symbolSize": 50
              },
              "markLine": {
                "data": [],
                "lineStyle": {
                  "type": "dashed"
                },
                "label": {
                  "color": "#fff"
                },
                "symbol": "none"
              },
              "label": {
                "normal": {
                  "show": false,
                  "position": "top",
                  "fontSize": 14,
                  "color": "inherit"
                }
              }
            }
          },
          "distributorUserCumulative": {
            "xAxis": {
              "data": ["2022-01", "2022-02", "2022-03", "2022-04"]
            },
            "series": [{
              "name": "累计",
              "data": [3200, 3420, 3590, 3765, 3890, 3950, 4080],
              "type": "line",
              "stack": "数量",
              "areaStyle": []
            }]
          }, // 联盟用户累计
          "theme_color_2390": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
          "chartOptions_random_4631": {
            "tooltip": {
              "show": true,
              "autoToolTip": true,
              "trigger": "axis",
              "axisPointer": {
                "type": "shadow"
              },
              "textStyle": {
                "color": "rgba(255, 255, 255, 1)",
                "fontSize": 15
              },
              "backgroundColor": "rgba(0, 0, 0, 0.8)",
              "borderColor": "rgba(255, 0, 0, 0)"
            },
            "legend": {
              "type": "scroll",
              "textStyle": {
                "color": "#fff"
              },
              "show": false,
              "orient": "horizontal",
              "left": "center",
              "top": ""
            },
            "grid": {
              "left": "2%",
              "right": "3%",
              "bottom": "4%",
              "top": "15%",
              "containLabel": true
            },
            "xAxis": {
              "type": "category",
              "axisTick": {
                "show": false
              },
              "axisLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              },
              "axisLabel": {
                "show": true,
                "color": "#fff",
                "fontSize": 14,
                "fontWeight": 500,
                "rotate": 20
              },
              "splitLine": {
                "show": false,
                "lineStyle": {
                  "color": "#6E7079"
                }
              }
            },
            "yAxis": {
              "type": "value",
              "axisTick": {
                "show": false
              },
              "axisLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              },
              "axisLabel": {
                "show": true,
                "color": "rgba(255, 255, 255, 1)",
                "fontSize": 14,
                "fontWeight": 400
              },
              "splitLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.1)"
                }
              }
            },
            "barSetting": {
              "barWidth": 16,
              "markPoint": {
                "label": {
                  "normal": {
                    "textStyle": {
                      "color": "#fff",
                      "fontSize": 14,
                      "fontWeight": 400
                    }
                  }
                },
                "itemStyle": [],
                "data": [],
                "symbol": "pin",
                "symbolSize": 50
              },
              "label": {
                "normal": {
                  "show": true,
                  "position": "top",
                  "fontSize": 14,
                  "color": "rgba(255, 140, 25, 1)"
                }
              },
              "markLine": {
                "label": {
                  "color": "#fff"
                },
                "symbol": "none",
                "lineStyle": {
                  "type": "dashed"
                },
                "data": []
              }
            }
          },
          "distributorUserGrowth": {
            "xAxis": {
              "data": ["2026-01-19", "2026-01-20", "2026-01-21", "2026-01-22", "2026-01-23"]
            },
            "series": [{
              "name": "用户数量",
              "data": [120, 120, 180, 100, 190],
              "type": "bar"
            }]
          }, // 联盟用户增长
          "theme_color_6488": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
          "distributorUserAmountList": {
            "columns": [{
              "name": "用户名",
              "prop": "username"
            }, {
              "name": "订单金额",
              "prop": "orderprice"
            }],
            "rows": [{
              "username": "用户名1",
              "orderprice": 200
            }, {
              "username": "用户名1",
              "orderprice": 200
            }, {
              "username": "用户名1",
              "orderprice": 200
            }, {
              "username": "用户名1",
              "orderprice": 200
            }, {
              "username": "用户名1",
              "orderprice": 200
            }]
          }, // 近一月联盟订单金额
          "theme_color_3245": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
          "distributorUserInviteList": {
            "columns": [{
              "name": "用户名",
              "prop": "username"
            }, {
              "name": "邀请用户",
              "prop": "inviteusers"
            }],
            "rows": [
             ]
          }, // 近一月联盟邀请用户
          "distributorOrderAmount7": {
            "data": 554
          }, // 近7天分销订单金额
          "distributorAmount7": {
            "data": 65
          }, // 近7天分佣金额
          "distributorOrderCount7": {
            "data": 4455
          }, // 近7天分销单数
          "inviteUserCount": {
            "data": 98
          }, // 联盟邀请注册
          "distributorUserCount": {
            "data": 22
          }, // 联盟用户总数
          "theme_color_1549": ["#F27B60", "#F8A200", "#B0D630", "#6EC890", "#2d3c98", "#6AE7E6", "#0F36A2", "#FC658A"],
          "distributorUserOrderCount": {
            "columns": [{
              "name": "用户名",
              "prop": "username"
            }, {
              "name": "完成单量",
              "prop": "ordernum"
            }, {
              "name": "成员数量",
              "prop": "usernum"
            }, {
              "name": "订单金额",
              "prop": "orderprice"
            }, {
              "name": "联盟佣金",
              "prop": "brokerage"
            }],
            "rows": [{
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }, {
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }, {
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }, {
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }, {
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }, {
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }, {
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }, {
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }, {
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }, {
              "username": "用户名1",
              "ordernum": 2,
              "usernum": 3,
              "orderprice": 12.00,
              "brokerage": 5
            }]
          }, // 近一月联盟用户完成单量
          "theme_color_6672": ["#6EC890", "#6AE7E6", "#F27B60", "#F8A200", "#B0D630", "#2d3c98", "#0F36A2", "#FC658A"],
          "chartOptions_random_5843": {
            "tooltip": {
              "show": true,
              "trigger": "axis",
              "axisPointer": {
                "type": "shadow"
              },
              "textStyle": {
                "color": "inherit",
                "fontSize": 14
              }
            },
            "legend": {
              "type": "scroll",
              "textStyle": {
                "color": "#fff"
              },
              "show": false,
              "orient": "horizontal",
              "left": "center",
              "top": ""
            },
            "grid": {
              "left": "1%",
              "right": "2%",
              "bottom": "0%",
              "top": "15%",
              "containLabel": true
            },
            "yAxis": {
              "type": "value",
              "axisTick": {
                "show": false
              },
              "axisLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              },
              "axisLabel": {
                "show": true,
                "color": "#fff",
                "fontSize": 12,
                "fontWeight": 400
              },
              "splitLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              }
            },
            "xAxis": {
              "type": "category",
              "boundaryGap": false,
              "axisTick": {
                "show": true
              },
              "axisLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              },
              "axisLabel": {
                "show": true,
                "color": "#fff",
                "fontSize": 12,
                "fontWeight": 400,
                "rotate": 0
              },
              "splitLine": {
                "show": false,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              }
            },
            "seriesSetting": {
              "areaStyle": {
                "show": true
              },
              "markPoint": {
                "label": {
                  "normal": {
                    "textStyle": {
                      "color": "#fff",
                      "fontSize": 14,
                      "fontWeight": 400
                    }
                  }
                },
                "itemStyle": [],
                "data": [],
                "symbol": "pin",
                "symbolSize": 50
              },
              "markLine": {
                "data": [],
                "lineStyle": {
                  "type": "dashed"
                },
                "label": {
                  "color": "#fff"
                },
                "symbol": "none"
              },
              "label": {
                "normal": {
                  "show": false,
                  "position": "top",
                  "fontSize": 14,
                  "color": "inherit"
                }
              }
            }
          },
          "distributorCountChart": {
            "xAxis": {
              "data": ["2022-01", "2022-02", "2022-03", "2022-04"]
            },
            "series": [{
              "name": "订单",
              "data": [3200, 3420, 3590, 3765, 3890, 3950, 4080],
              "type": "line",
              "stack": "数量",
              "areaStyle": []
            }]
          }, // 联盟订单
          "chartOptions_random_4442": {
            "tooltip": {
              "show": true,
              "autoToolTip": true,
              "trigger": "axis",
              "axisPointer": {
                "type": "shadow"
              },
              "textStyle": {
                "color": "rgba(255, 255, 255, 1)",
                "fontSize": 15
              },
              "backgroundColor": "rgba(0, 0, 0, 0.8)",
              "borderColor": "rgba(255, 0, 0, 0)"
            },
            "legend": {
              "type": "scroll",
              "textStyle": {
                "color": "#fff"
              },
              "show": false,
              "orient": "horizontal",
              "left": "center",
              "top": ""
            },
            "grid": {
              "left": "2%",
              "right": "3%",
              "bottom": "4%",
              "top": "15%",
              "containLabel": true
            },
            "xAxis": {
              "type": "category",
              "axisTick": {
                "show": false
              },
              "axisLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              },
              "axisLabel": {
                "show": true,
                "color": "#fff",
                "fontSize": 14,
                "fontWeight": 500,
                "rotate": 20
              },
              "splitLine": {
                "show": false,
                "lineStyle": {
                  "color": "#6E7079"
                }
              }
            },
            "yAxis": {
              "type": "value",
              "axisTick": {
                "show": false
              },
              "axisLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.2)"
                }
              },
              "axisLabel": {
                "show": true,
                "color": "rgba(255, 255, 255, 1)",
                "fontSize": 14,
                "fontWeight": 400
              },
              "splitLine": {
                "show": true,
                "lineStyle": {
                  "color": "rgba(255, 255, 255, 0.1)"
                }
              }
            },
            "barSetting": {
              "barWidth": 16,
              "markPoint": {
                "label": {
                  "normal": {
                    "textStyle": {
                      "color": "#fff",
                      "fontSize": 14,
                      "fontWeight": 400
                    }
                  }
                },
                "itemStyle": [],
                "data": [],
                "symbol": "pin",
                "symbolSize": 50
              },
              "label": {
                "normal": {
                  "show": true,
                  "position": "top",
                  "fontSize": 14,
                  "color": "rgba(0, 254, 137, 1)"
                }
              },
              "markLine": {
                "label": {
                  "color": "#fff"
                },
                "symbol": "none",
                "lineStyle": {
                  "type": "dashed"
                },
                "data": []
              }
            }
          },
          "distributorAmountChart": {
            "xAxis": {
              "data": ["2026-01-19", "2026-01-20", "2026-01-21", "2026-01-22", "2026-01-23"]
            },
            "series": [{
              "name": "销售额",
              "data": [150, 220, 180, 200, 190],
              "type": "bar"
            }]
          } // 联盟订单交易金额
        };

      },
      filters: {},
      created() {
        if (getUrlKey('viewSource')) {
          this.viewSource = getUrlKey('viewSource');
        }
        this.getDistributorStatistics()
        this.getDistributorAmountChart()
        this.getDistributorGoodsAmountChart()
        this.getDistributorUserInviteList()
        this.getDistributorUserAmountList()
        this.getDistributorUserGrowth()
        this.getDistributorUserCumulative()
      },
      mounted() {

        let that = this;
        window.onresize = () => {
          that.screenWidth = that.$refs.antdVue.offsetWidth
          that.screenHeight = that.$refs.antdVue.offsetHeight
          that.handleResize();
        }
        this.$nextTick(() => {
          that.handleResize();
        })
      },
      computed: {},
      watch: {
        screenWidth(val) {
          if (!this.timerW) {
            let that = this;
            // that.screenWidth = val;
            this.timerW = true;
            that.handleResize();
            setTimeout(function () {
              that.timerW = false;
            }, 400)
          }
        },
        screenHeight(val) {
          if (!this.timerH) {
            let that = this;
            // that.screenHeight = val;
            this.timerH = true;
            that.handleResize();
            setTimeout(function () {
              that.timerH = false;
            }, 400)
          }
        }
      },
      methods: {
        moment,
        themeColorInit,
        isEmpty,
        //统一获取自定义接口
        get_diy_api_page() {

        },
        getDistributorAmountChart() {
          let param = {
            chartType: "months",
            startTime: moment().subtract(4, 'month').format('YYYY-MM-DD HH:mm:ss'),
            endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          }
          distributorAmountChart(param).then(response => {
            this.distributorAmountChart = {
              xAxis: {
                data: response.data.xxAxis
              },
              series: [{
                name: "销售额",
                data: response.data.yyAxis.distributorOrderAmountList || [],
                type: "bar"
              }]
            }

            this.distributorCountChart = {
              xAxis: {
                data: response.data.xxAxis
              },
              series: [{
                name: "订单",
                data: response.data.yyAxis.distributorOrderAmountList || [],
                type: "line",
                stack: "数量",
                areaStyle: []
              }]
            }
          })
        },

        getDistributorGoodsAmountChart() {
          let param = {
            startTime: moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
            endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          }
          distributorGoodsAmountChart(param).then(response => {
            const rows = response.data.map(item => ({
              'shopname': item.goodsName,
              'ordernum': item.distributorOrderCount,
              'shopprice': item.price,
              'award': item.distributorAmount,

            }));
            this.distributorGoodsAmountChart = {
              "columns": [{
                "name": "商品名称",
                "prop": "shopname"
              }, {
                "name": "完成单量",
                "prop": "ordernum"
              }, {
                "name": "商品单价",
                "prop": "shopprice"
              }, {
                "name": "奖励总额度",
                "prop": "award"
              }],
              rows:rows
            }
          })
        },

        getDistributorStatistics() {
          let param = {
          }
          distributorStatistics(param).then(response => {
            this.distributorUserCount = {data: response.data.distributorUserCount}
            this.inviteUserCount = {data: response.data.inviteUserCount}
            this.distributorOrderCount7 = {data: response.data.distributorOrderCount7}
            this.distributorOrderAmount7 = {data: response.data.distributorOrderAmount7}
            this.distributorAmount7 = {data: response.data.distributorAmount7}
          })
        },

        getDistributorUserInviteList() {
          let param = {
            pageNum:1,
            pageSize: 10,
            startTime: moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
            endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          }
          distributorUserInviteList(param).then(response => {
            const rows = response.data.map(item => ({
              'username': item.nickName,
              'inviteusers': item.inviteNickName,
            }));
            this.distributorUserInviteList = {
              "columns": [{
                "name": "用户名",
                "prop": "username"
              }, {
                "name": "邀请用户",
                "prop": "inviteusers"
              }],
              rows:rows
            }

          })
        },

        getDistributorUserAmountList() {
          let param = {
            pageNum:1,
            pageSize: 10,
            startTime: moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
            endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          }
          distributorUserAmountChart(param).then(response => {
            const rows = response.data.map(item => ({
              'username': item.nickName,
              'orderprice': item.payAmount,
            }));
            this.distributorUserAmountList = {
              "columns": [{
                "name": "用户名",
                "prop": "username"
              }, {
                "name": "订单金额",
                "prop": "orderprice"
              }],
              rows:rows
            }


            const rows2 = response.data.map(item => ({
              'username': item.nickName,
              'orderprice': item.payAmount,
              'ordernum': item.orderCount,
              'usernum': item.inviteUserCount,
              'brokerage': item.distributorAmount,

            }));
            this.distributorUserOrderCount = {
              "columns": [{
                "name": "用户名",
                "prop": "username"
              }, {
                "name": "完成单量",
                "prop": "ordernum"
              }, {
                "name": "成员数量",
                "prop": "usernum"
              }, {
                "name": "订单金额",
                "prop": "orderprice"
              }, {
                "name": "联盟佣金",
                "prop": "brokerage"
              }],
              rows:rows2
            }

          })
        },


        getDistributorUserGrowth() {
          let param = {
            chartType: "months",
            startTime: moment().subtract(4, 'month').format('YYYY-MM-DD HH:mm:ss'),
            endTime: moment().format('YYYY-MM-DD HH:mm:ss'),
          }
          distributorUserGrowth(param).then(response => {
            this.distributorUserGrowth = {
              "xAxis": {
                data: response.data.xxAxis
              },
              "series": [{
                "name": "用户数量",
                data: response.data.yyAxis.distributorUserCountList,
                "type": "bar"
              }]
            }
          })
        },

        getDistributorUserCumulative() {
          let param = {
            chartType: "months",
            startTime: moment().subtract(4, 'month').format('YYYY-MM-DD HH:mm:ss'),
          }
          distributorUserCumulative(param).then(response => {
            this.distributorUserCumulative = {
              "xAxis": {
                data: response.data.xxAxis
              },
              "series": [{
                "name": "累计",
                data: response.data.yyAxis.distributorUserCountList,
                "type": "line",
                "stack": "数量",
                "areaStyle": []
              }]
            }
          })
        },


        handleResize() {
          let that = this;
          this.$nextTick(() => {
            that.screenWidth = that.$refs.antdVue.offsetWidth
            that.screenHeight = that.$refs.antdVue.offsetHeight
            let screenWidth = that.screenWidth;
            let screenHeight = that.screenHeight;
            let scale = Math.min(screenWidth / this.designWidth, screenHeight / this.designHeight);
            let horizontalOffset = (screenWidth - this.designWidth * scale) / 2;
            that.calculateStyles = {
              transformOrigin: 'top left',
              transform: `translateX(${horizontalOffset}px)  scale(${scale}) `,
            };
          });
        }
      }
    }
</script>
<style lang="less" scoped>
    @import '../../assets/diypaaspc/diy-pass-big-screen.css';
    @import '../../assets/diypaaspc/library-ant-design-vue.css';

    .antdVue {
        position: relative;
        width: 100%;
        width: 1920px;
        height: 1080px;
        background: transparent;
        background-size: 100% auto !important;
    }

    .zoom_bg_color {
        background: rgba(2, 8, 15, 0);
    }

    #antdVue .lianmengfenxidaping_306_random_flex_0 {
        background-position: 0px 10px;
    }

    #antdVue .lianmengfenxidaping_807_fd0_1_c1_c1_c0_c1 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240402/2ae98f8892c4b37628e48e51a5d0abd1.png) no-repeat;
        height: 4px;
        margin: 16px 0px 0px 0px;
    }

    #antdVue .lianmengfenxidaping_883_fd0_1_c1_c1_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240403/99b08422a38374255b0a0c4fd40bb6e0.png) no-repeat;
        width: 49%;
        margin: 8px 0px 0px 0px;
        height: 288px;
        padding: 16px;
    }

    #antdVue .lianmengfenxidaping_387_random_fd0_1_c1_c0_c0_c2_c0_c1_c0 {
        color: rgba(255, 140, 25, 1);
        font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
        line-height: 36px;
    }

    #antdVue .lianmengfenxidaping_970_fd0_1_c1_c0_c0_c2 {
        margin: 25px 0px 0px 0px;
        padding: 0px 65px 0px 65px;
    }

    #antdVue .lianmengfenxidaping_929_random_fd0_1_c1_c0_c0_c1_c0_c1_c0 {
        color: rgba(255, 140, 25, 1);
        line-height: 36px;
        font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
    }

    #antdVue .lianmengfenxidaping_743_fd0_1_c1_c0_c0_c1 {
        margin: 122px 0px 0px 0px;
        padding: 0px 65px 0px 65px;
    }

    #antdVue .lianmengfenxidaping_121_random_fd0_1_c1_c0_c0_c0_c1_c1 {
        font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
        color: rgba(255, 140, 25, 1);
        line-height: 36px;
    }

    #antdVue .lianmengfenxidaping_578_fd0_1_c1_c0_c0_c0_c1_c0 {
        font-weight: 800;
        font-family: Source Han Sans CN, Source Han Sans CN;
        text-shadow: 0px 0px 16px rgba(167, 240, 255, 0.6);
        margin: 0px 0px 5px 0px;
    }

    #antdVue .lianmengfenxidaping_517_random_fd0_1_c1_c0_c0_c0_c0_c1 {
        color: #FF8C19;
        font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
        text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.6);
    }

    #antdVue .lianmengfenxidaping_152_fd0_1_c1_c0_c0_c0_c0_c0 {
        font-weight: 800;
        font-family: Source Han Sans CN, Source Han Sans CN;
        text-shadow: 0px 0px 16px rgba(167, 240, 255, 0.6);
    }

    #antdVue .lianmengfenxidaping_923_fd0_1_c1_c0_c0_c0_c0 {
        width: 200px;
    }

    #antdVue .lianmengfenxidaping_924_fd0_1_c1_c0_c0_c0 {
        margin: 170px 0px 0px 0px;
    }

    #antdVue .lianmengfenxidaping_707_fd0_1_c1_c0_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240418/0926a2dae56787e8d2371f0e0d13fcac.png) no-repeat;
        height: 608.58px;
        margin: 0px 7px 0px 7px;
        min-height: 608.58px;
    }

    #antdVue .lianmengfenxidaping_795_fd0_1_c0_c0_c2_c2_c0_c0_c0 {
        max-width: 20px;
        max-height: 20px;
    }

    #antdVue .lianmengfenxidaping_847_random_fd0_1_c0_c0_c2_c2_c0 {
        text-align: left;
        --header-bg: transparent;
        --header-text-color: rgb(255, 255, 255);
        --header-text-font-size: 16px;
    }

    #antdVue .lianmengfenxidaping_484_random_fd0_1_c0_c0_c1_c2_c0 {
        height: 180px;
    }

    #antdVue .lianmengfenxidaping_217_fd0_1_c0_c0_c0_c1 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240402/2ae98f8892c4b37628e48e51a5d0abd1.png) no-repeat;
        height: 4px;
        margin: 16px 0px 16px 0px;
    }

    #antdVue .lianmengfenxidaping_531_fd0_1_c0_c0_c0_c0 {
        font-weight: 800;
    }

    #antdVue .lianmengfenxidaping_853_fd0_1_c0_c0_c0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240403/99b08422a38374255b0a0c4fd40bb6e0.png) no-repeat;
        height: 288px;
        padding: 16px;
        border-radius: 8px;
        min-height: 288px;
    }

    #antdVue .lianmengfenxidaping_111_random_fd0_0_c5 {
        width: 70px;
        height: 70px;
        --full-screen-color: rgba(255, 255, 255, 1);
        --full-screen-width: 35px;
        --full-screen-height: 35px;
        top: 28px;
        right: 100px;
        z-index: 99;
    }

    #antdVue .lianmengfenxidaping_948_random_fd0_0_c4_c1 {
        color: rgba(255, 255, 255, 1);
    }

    #antdVue .lianmengfenxidaping_900_fd0_0_c4_c0 {
        width: 32px;
        height: 32px;
        border-radius: 0px 0px 0px 0px;
        margin: 0px 8px 0px 0px;
    }

    #antdVue .lianmengfenxidaping_951_fd0_0_c4 {
        width: 300px;
        top: 38px;
        right: 180px;
        height: 50px;
    }

    #antdVue .lianmengfenxidaping_512_fd0_0_c3 {
        width: 48px;
        height: 48px;
        border-radius: 0px 0px 0px 0px;
        margin: 0px 0px 0px 8px;
    }

    #antdVue .lianmengfenxidaping_202_fd0_0_c1 {
        width: 48px;
        height: 48px;
        margin: 0px 8px 0px 0px;
    }

    #antdVue .lianmengfenxidaping_919_fd0_0_c0_c3 {
        margin: 0px 0px 0px 8px;
        line-height: 10px;
    }

    #antdVue .lianmengfenxidaping_171_fd0_0_c0_c2 {
        background: linear-gradient(180deg, rgba(216, 226, 255, 0) 0%, #E3EAFF 49%, rgba(216, 226, 255, 0) 100%);
        width: 2px;
        height: 16px;
        margin: 0px 0px 0px 8px;
    }

    #antdVue .lianmengfenxidaping_355_fd0_0_c0_c1 {
        margin: 0px 0px 0px 8px;
    }

    #antdVue .lianmengfenxidaping_976_fd0_0_c0_c0 {
        width: 32px;
        height: 32px;
        border-radius: 0px 0px 0px 0px;
    }

    #antdVue .lianmengfenxidaping_224_fd0_0_c0 {
        top: 38px;
        left: 82px;
        height: 50px;
    }

    #antdVue .lianmengfenxidaping_213_fd0_0 {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/95867b2fe8e71f9cd1cf14259ed09824.png) no-repeat;
        font-size: 48px;
        height: 135px;
        font-weight: 800;
    }

    .zoom_bg_color {
        background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240218/28580720a4073072604131817b3e36d2.png) center center / 100% 100% no-repeat !important
    }
</style>